/**
 * Volatile VGS CVV alias captured at card alta.
 * Memory only — never localStorage, sessionStorage, or Zustand persist.
 * A full reload asks for CVV again. 60 minutes is the safe floor versus a
 * VGS alias TTL of 1 hour or 24 hours.
 */
const aliases = new Map<string, { token: string; capturedAt: number }>();

export const FRESH_CVV_TTL_MS = 60 * 60 * 1000;

export const rememberFreshCvv = (
  paymentMethodId: string,
  cvvToken: string,
  capturedAt = Date.now(),
): void => {
  if (!paymentMethodId || !cvvToken) return;
  aliases.set(paymentMethodId, { token: cvvToken, capturedAt });
};

/** Returns the alias while it is younger than 60 minutes. Drops it otherwise. */
export const peekFreshCvv = (
  paymentMethodId: string,
  at = Date.now(),
): string | undefined => {
  const entry = aliases.get(paymentMethodId);
  if (!entry) return undefined;
  if (at - entry.capturedAt >= FRESH_CVV_TTL_MS) {
    aliases.delete(paymentMethodId);
    return undefined;
  }
  return entry.token;
};

export const forgetFreshCvv = (paymentMethodId: string): void => {
  aliases.delete(paymentMethodId);
};

export const clearFreshCvvAliases = (): void => {
  aliases.clear();
};
